@if (menu().length > 0) {

  <mat-nav-list>

    <mat-list-item>
      <mat-icon matListItemIcon color='primary'>account_circle</mat-icon>
      <span class='matero-username hide-lt-sm' matListItemTitle>{{ user()?.mail }}</span>
    </mat-list-item>

    <ng-container *ngFor='let menuItem of menu()'>
      <mat-list-item *ngIf='menuItem | access | async'
                     [routerLink]='menuItem.link'>
        <mat-icon matListItemIcon>{{ menuItem.icon }}</mat-icon>
        <span matListItemTitle class="{{menuItem?.id}}-link">{{ menuItem.name }}</span>
      </mat-list-item>
    </ng-container>
  </mat-nav-list>

  <div class='version-container'>
    <div>Version {{ version }}</div>
    <div>
      <a href='javascript:' (click)='openReleaseNotesDialog()' target='_self'>Release Notes</a>
    </div>

    <div [style.margin-top.px]='20'>
      <a href='javascript:' (click)='openUserManual()' target='_self'>Anwenderdokumentation</a>
    </div>
  </div>
}

